module.exports = __webpack_public_path__ + "img/refresh-dark.14e48704.svg";